const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/labReports/loadCumulDefsHandlers.ts';
import Imm from 'immutable';
import { incCounter, decCounter } from '../../utils/reducerUtils';
import { IKisApiHandlersMap } from '../../defs/actionTypes';
import { LoadCumulDefsAction } from '../../actions/labReportsActions';
import { Logger } from '../../services/KisLoggerService';

const Log = Logger('labReports/loadCumulDefs');
const emptyMap = Imm.Map<string, any>();

export const loadCumulDefsHandlers: IKisApiHandlersMap<LoadCumulDefsAction> = {
    pending: state => {
        return incCounter(state, ['loading', 'cumulDefs']);
    },
    success: (state, action) => {
        // Start with a hidden entry for cumulative reports through a separate mapping.

        let map = emptyMap.set('0', Imm.fromJS({ Name: 'Via Mapping', hidden: '1' }));

        // Add entries from payload.

        const list = Imm.fromJS((action.payload && action.payload.List) || []);

        if (!list.size) {
            Log.warn('Received an empty list of cumulDefs!');
        } else {
            // The filters have recently been nested into groups (see MetaKat SZB/dev).
            // At the moment, we cannot handle them, so let's simply flatten the hierarchy!

            list.sortBy((_: Imm.Map<string, any>, key: string) => {
                // Sorting the given list by key numerically gives us a depth-first list
                // where the children appear ordered by their POS.
                return Number(key || 0);
            })
                .filter((entry: Imm.Map<string, any>) => {
                    // Throwing away all the parent nodes gives us the flattened list.
                    const isFilter = entry.get('KAT') === 'LabKumFilter';
                    const hasChildren = entry.get('CHILD') === '+';
                    return isFilter && !hasChildren;
                })
                .forEach((entry: Imm.Map<string, any>, idx: number) => {
                    const icode = entry.get('ICODE');
                    const name = entry.get('NAME');

                    if (!icode || !name) {
                        Log.warn('Skipping cumulDefs with missing mandatory members', entry);
                    } else {
                        const defsId = `${idx + 1}`;
                        map = map.set(
                            defsId,
                            Imm.fromJS({
                                Name: name,
                                FilterIcode: icode,
                            })
                        );
                    }
                });

            state = state.set('cumulDefs', map);
        }

        return decCounter(state, ['loading', 'cumulDefs']);
    },
    failure: (state, action) => {
        Log.warn('Failed to load the cumulDefs!', action);
        return decCounter(state, ['loading', 'cumulDefs']);
    },
};
